import styled from 'styled-components'
import { brandOrange, brandWhite } from '../../../assets/consts/color'

export const AccreditationList = styled.ul`
  display: grid;
  gap: 20px;

  @media only screen and (min-width: 48em) {
    grid-template-rows: repeat(${({ rows }) => rows}, auto);
    grid-auto-flow: column;
    column-gap: 30px;
  }
`
export const ImageFilter = styled.div`
  border-radius: 4px;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  z-index: 2;
  background-color: ${brandOrange};
  mix-blend-mode: overlay;
  opacity: 0;
  transition: 0.25s;
`

export const CtaLink = styled.a`
  display: flex;
  align-items: center;
  gap: 20px;
  text-decoration: none;

  &:hover {
    @media (hover: hover) {
      ${ImageFilter} {
        opacity: 1;
      }
    }
  }
`
export const ItemContainer = styled.div`
  align-items: center;
  gap: 20px;

  .item-subtitle {
    font-size: 14px;
  }

  svg {
    vertical-align: text-top;
    margin-left: 5px;
  }
`
export const ImageWrapper = styled.div`
  width: 39px;
  flex-shrink: 0;
  background-color: ${brandWhite};
  position: relative;
  overflow: hidden;
`
